import { Base64 } from 'js-base64';

export const encodeToBase64Url = (value: string): string => Base64.encodeURI(value);

export const decodeFromBase64Url = (value: string): string => Base64.decode(value);
